"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { captureDiscoveryEvent } from "@/lib/discovery/analytics";
import { PUBLIC_CITY_SLUGS } from "@/lib/constants";

export function DiscoveryAnalytics() {
  const pathname = usePathname();
  const lastPage = useRef<string | null>(null);
  useEffect(() => {
    const parts = pathname.split("/").filter(Boolean);
    if (["en", "de-CH"].includes(parts[0])) parts.shift();
    if (parts.length && !["artist", "jukebox", ...PUBLIC_CITY_SLUGS].includes(parts[0])) return;
    if (lastPage.current === pathname) return;
    lastPage.current = pathname;
    const pageKind = parts[0] === "artist" ? "artist" : parts[0] === "jukebox" ? "listening" : parts.includes("event") ? "event" : "browse";
    captureDiscoveryEvent("discovery_page_viewed", { page_kind: pageKind, path: pathname });
  }, [pathname]);

  useEffect(() => {
    const clicked = (event: MouseEvent) => {
      if (!(event.target instanceof Element)) return;
      const anchor = event.target.closest<HTMLAnchorElement>("a[data-ticket-link][href]");
      if (!anchor) return;
      const eventId = Number(anchor.dataset.eventId);
      captureDiscoveryEvent("discovery_ticket_clicked", { event_id: Number.isSafeInteger(eventId) && eventId > 0 ? eventId : undefined,
        destination: new URL(anchor.href).hostname });
    };
    document.addEventListener("click", clicked, true);
    return () => document.removeEventListener("click", clicked, true);
  }, []);
  return null;
}
